import EndPointConfig from '../../models/api/endPointConfig';

const controller = 'Products';

// Define all EndPoints for login agents methods.
export const ProductsEP : EndPointConfig[] = [
    new EndPointConfig().setMethod('GET').setController(controller).setAlias('GetProducts'),
];
